import React from 'react';
import { Box } from '@mui/material';
import MetricSkeleton from './MetricSkeleton';

export interface MetricGroupSkeletonProps {
    metrics?: number;
    showIcon?: boolean;
    showChangeRow?: boolean;
}

const MetricGroupSkeleton: React.FC<MetricGroupSkeletonProps> = ({
    metrics = 4,
    showIcon = false,
    showChangeRow = true,
}) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: 0.75,
            }}
        >
            {Array.from({ length: metrics }, (_, i) => (
                <MetricSkeleton key={i} showIcon={showIcon} showChangeRow={showChangeRow} />
            ))}
        </Box>
    );
};

export default MetricGroupSkeleton;
